/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetSemanticWorkbenchCompletionsQueryVariables = Types.Exact<{
  editableRegion: Types.Scalars["String"]["input"];
  prefix: Types.Scalars["String"]["input"];
  suffix: Types.Scalars["String"]["input"];
}>;

export type GetSemanticWorkbenchCompletionsQuery = {
  readonly __typename: "Query";
  readonly getSemanticWorkbenchCompletions: {
    readonly __typename: "CompletionResultV2";
    readonly result: string | null;
  };
};

export const GetSemanticWorkbenchCompletionsDocument = /*#__PURE__*/ gql`
  query GetSemanticWorkbenchCompletions(
    $editableRegion: String!
    $prefix: String!
    $suffix: String!
  ) {
    getSemanticWorkbenchCompletions(
      editableRegion: $editableRegion
      prefix: $prefix
      suffix: $suffix
    ) {
      result
    }
  }
`;

/**
 * __useGetSemanticWorkbenchCompletionsQuery__
 *
 * To run a query within a React component, call `useGetSemanticWorkbenchCompletionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSemanticWorkbenchCompletionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSemanticWorkbenchCompletionsQuery({
 *   variables: {
 *      editableRegion: // value for 'editableRegion'
 *      prefix: // value for 'prefix'
 *      suffix: // value for 'suffix'
 *   },
 * });
 */
export function useGetSemanticWorkbenchCompletionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSemanticWorkbenchCompletionsQuery,
    GetSemanticWorkbenchCompletionsQueryVariables
  > &
    (
      | {
          variables: GetSemanticWorkbenchCompletionsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSemanticWorkbenchCompletionsQuery,
    GetSemanticWorkbenchCompletionsQueryVariables
  >(GetSemanticWorkbenchCompletionsDocument, options);
}
export function useGetSemanticWorkbenchCompletionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSemanticWorkbenchCompletionsQuery,
    GetSemanticWorkbenchCompletionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSemanticWorkbenchCompletionsQuery,
    GetSemanticWorkbenchCompletionsQueryVariables
  >(GetSemanticWorkbenchCompletionsDocument, options);
}
export function useGetSemanticWorkbenchCompletionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSemanticWorkbenchCompletionsQuery,
    GetSemanticWorkbenchCompletionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSemanticWorkbenchCompletionsQuery,
    GetSemanticWorkbenchCompletionsQueryVariables
  >(GetSemanticWorkbenchCompletionsDocument, options);
}
export type GetSemanticWorkbenchCompletionsQueryHookResult = ReturnType<
  typeof useGetSemanticWorkbenchCompletionsQuery
>;
export type GetSemanticWorkbenchCompletionsLazyQueryHookResult = ReturnType<
  typeof useGetSemanticWorkbenchCompletionsLazyQuery
>;
export type GetSemanticWorkbenchCompletionsSuspenseQueryHookResult = ReturnType<
  typeof useGetSemanticWorkbenchCompletionsSuspenseQuery
>;
export type GetSemanticWorkbenchCompletionsQueryResult = Apollo.QueryResult<
  GetSemanticWorkbenchCompletionsQuery,
  GetSemanticWorkbenchCompletionsQueryVariables
>;
